import type { CSSProperties } from 'react';
import { theme } from '@noths/polaris-client-ribbons-base';
import { css } from 'styled-components';

const { fonts, responsiveText } = theme;

export interface TopBannerRootCSS extends CSSProperties {
  '--topBannerPosition'?: string;
}

export const root = css`
  position: var(--topBannerPosition, relative);
  top: 0;
  z-index: 10;
  display: flex;
  justify-content: space-between;
  width: 100%;
  left: 0;
  right: 0;
  transition: color 0.3s ease-in-out, background-color 0.3s ease-in-out;
`;

export const arrowButton = css`
  background: none;
  border: none;

  &:first-child > span {
    transform: rotate(180deg);
  }

  &:disabled {
    visibility: hidden;
  }
`;

export const message = css`
  display: none;
  height: 36px;
  padding: 0 6px;
  font-family: ${fonts.PRIMARY_SEMIBOLD.family};
  font-weight: ${fonts.PRIMARY_SEMIBOLD.weight};
  ${responsiveText.BODY.SM};

  &[aria-hidden='false'] {
    display: flex;
    align-items: center;
  }
`;

export const textColor = {
  ['Dark']: css`
    &,
    a {
      color: var(--neutral-black-base);
    }
  `,

  ['Light']: css`
    &,
    a {
      color: var(--neutral-white-base);
    }
  `,
};
